import getEsriData from "context/contextFunctions/getEsriData";

// eslint-disable-next-line consistent-return
export default async function getVillages({
  layerId,
  dispatch,
  villages,
  token,
  query = "1=1",
}) {
  if (!villages && layerId !== undefined) {
    const { res } = await getEsriData({
      token,
      layerId,
      layer: process.env.REACT_APP_DLS_Lockups_Table,
      outFields: "VILL_CODE,VILL_ANAME",
      returnDistinctValues: true,
      featureOrMap: "MapServer",
      returnGeometry: false,
      query,
    });
    if (dispatch)
      dispatch({
        type: "INIT",
        payload: { villages: res },
      });
    return res;
  }
}
